import { Link } from 'react-router-dom';
import './NotFoundPage.css';

export default function NotFoundPage() {
  return (
    <div className="not-found">
      <div className="not-found__code">404</div>
      <div className="not-found__label">{'// SIGNAL NOT FOUND'}</div>
      <p className="not-found__msg">The path you requested does not exist in this instance.</p>
      <Link to="/" className="not-found__link">
        ← RETURN TO ANALYSIS
      </Link>
    </div>
  );
}
